import { Typography } from '@material-tailwind/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import OverlayUnTouchable from '../../layouts/pagesLayouts/OverlayUnTouchable'
import PageLayout from '../../layouts/pagesLayouts/PageLayout'
import TableLayout from '../../layouts/pagesLayouts/TableLayout'
import { usePaymentsViewQuery } from '../../store/auth/authService'
import { setContractId, setServiceId } from '../../store/service/contractSlice'
import { AppDispatch } from '../../store/store'
import { isIterableArray, replacedString } from '../../utils/utils'
import TableSortingCreator from '../tableHelpers/TableSortingCreator'
import PaymentsFilters from './PaymentsFilters'
import { PaymentRowType } from './PaymentsPage.types'
import PaymentsTableDumb from './PaymentsTableDumb'
import { Helmet } from 'react-helmet'
import useRolePage from '../../utils/useRolePage'
import ErrorCatchLayout from '../../layouts/pagesLayouts/ErrorCatchLayout'


type FilterFormType = {
    contract_id: string | undefined,
    type?: number[],
    type_invoice?: number[],
    balance?: number[],
    date_payment?: string[],
}


const PaymentsPage = () => {

    const { data: roles } = useRolePage();

    const { param_contract_id } = useParams()
    const { t } = useTranslation()

    const form: FilterFormType = {
        contract_id: param_contract_id,
        type: [],
        type_invoice: [],
        balance: [],
        date_payment: [],
    }

    const [sendForm, setSendForm] = useState<FilterFormType>(form);
    const dispatch = useDispatch<AppDispatch>()


    const { data, error, isLoading, isFetching, refetch } = usePaymentsViewQuery(sendForm)

    // array all rows
    const [rows, setRows] = useState<PaymentRowType[]>([]);

    const [tableRows, setTableRows] = useState<PaymentRowType[]>([]);
    const [search, setSearch] = useState<string>('');

    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(true);


    useEffect(() => {
        dispatch(setContractId(Number(param_contract_id)))
    }, [param_contract_id]);

    useEffect(() => {
        if (data?.service_id) dispatch(setServiceId(Number(data.service_id)))
    }, [data]);

    const setFormForFetch = (values: any) => {
        setIsLoadingTable(true)
        setTableRows([])
        setSendForm(prev => ({
            ...prev, ...{
                ...values,
                contract_id: param_contract_id
            }
        }))
    }

    useEffect(() => {
        if (
            !isLoading && !isFetching && isIterableArray(tableRows) ||
            !isLoading && !isFetching && Array.isArray(data?.rows) && !isIterableArray(data?.rows)
        ) {
            setIsLoadingTable(false)
        }
    }, [isLoading, isFetching, tableRows, data?.rows]);

    // ______CREATE_DATA
    useEffect(() => {
        if (isIterableArray(data?.rows)) {
            const res: PaymentRowType[] = data.rows.map((item: PaymentRowType) => createData(item))
            setRows(res)
        }
        else setRows([])
    }, [data]);

    useEffect(() => {
        onSearch(search)
    }, [rows]);

    const onSearch = (searchValue: string) => {
        setSearch(searchValue);
        const reg = new RegExp(replacedString(searchValue), "gi");
        if (searchValue === "") {
            setTableRows(rows)
            return
        }
        if (isIterableArray(rows)) {
            const filteredData: PaymentRowType[] = rows.filter((item: any) => {
                const keys = Object.keys(item);
                let matches = 0;
                keys.forEach((key) => {
                    const val = replacedString(String(item[key]))
                    if (reg.test(val)) matches++;
                });
                return matches > 0;
            });
            if (searchValue !== "" && filteredData.length > 0) {
                setTableRows(filteredData);
            }
            if (searchValue !== "" && filteredData.length === 0) {
                setTableRows([]);
            }
        }


    };


    function createData(data: PaymentRowType) {
        return {
            key: data.key,
            // id: `${data.id}${Math.random()}`,
            period: data.period,
            period_sorter: data.period_sorter,
            invoice_number: data.invoice_number ? data.invoice_number : '—',
            date: data.date,
            date_sorter: data.date_sorter,
            row_type: data.row_type ? t(`payments_page.row_type_${data.row_type}`) : '—',
            invoice_type: data.invoice_type ? t(`invoices_page.invoice_type_${data.invoice_type}`) : '—',
            balance_id: data.balance_id ? t(`balance_${data.balance_id}`) : '—',
            order_pay: data.order_pay ? data.order_pay : '—',
            amount: data.amount,
            pay_purpose: data.pay_purpose ? data.pay_purpose : '—',
        };
    }


    return (
        <PageLayout title={
            <Typography variant='h3' className='text-gray-800 text-center mb-[64px]'>
                {t('payments_page.payments_title')}
            </Typography>
        }>
            <Helmet>
                <title>
                    {t('payments_page.payments_title')}
                </title>
            </Helmet>
            <OverlayUnTouchable isOverlay={false} errorForbidden={error}>
                <PaymentsFilters
                    isLoadingFetch={isFetching}
                    fetchPage={setFormForFetch}
                    onSearch={onSearch}
                />
            </OverlayUnTouchable>
            <OverlayUnTouchable isOverlay={(isFetching || isLoading || !!error)}>
                {
                    error ?
                        <ErrorCatchLayout error={error} refetch={refetch} />
                        :
                        <TableSortingCreator
                            roles={roles}
                            isLoadingTable={isLoadingTable}
                            Component={PaymentsTableDumb}
                            rows={tableRows}
                        />
                }
            </OverlayUnTouchable>
        </PageLayout>
    )
}

export default PaymentsPage
